import React from 'react';
import { SetExamQuestion } from '../utils/questionApi';

interface Props {
  question: SetExamQuestion;
  qIdx: number;
  selected: number[];
  isChecked: boolean;
  isPracticeMode: boolean;
  onToggle: (qIdx: number, optIdx: number) => void;
  onCheck: (qIdx: number) => void;
}

export const lettersOf = (idxs: number[]): string => idxs.map(i => String.fromCharCode(65 + i)).join(', ');
export const sameAnswer = (a: number[], b: number[]): boolean => a.length === b.length && a.every(x => b.includes(x));

const ExamQuestionCard: React.FC<Props> = ({ question, qIdx, selected, isChecked, isPracticeMode, onToggle, onCheck }) => {
  const required = question.ans.length;
  const multi = required > 1;
  const isCorrect = sameAnswer(selected, question.ans);
  const isUnanswered = selected.length === 0;
  const canCheck = isPracticeMode && !isChecked && selected.length === required;

  return (
    <div className="q-card">
      <div className="q-header">
        <div className="q-num">{qIdx + 1}</div>
        <div className="q-text" style={{ whiteSpace: 'pre-wrap' }}>{question.q}</div>
      </div>
      {multi && (
        <div style={{ fontSize: '0.78rem', fontWeight: 700, color: 'var(--orange)', margin: '0 0 8px 2px' }}>
          Choose {required} answers
        </div>
      )}
      <div className="q-options">
        {question.opts.map((opt, optIdx) => {
          const isSel = selected.includes(optIdx);
          let cls = '';
          if (isChecked) {
            if (question.ans.includes(optIdx)) cls = 'correct';
            else if (isSel) cls = 'wrong';
          } else if (isSel) {
            cls = 'selected';
          }
          return (
            <div
              key={optIdx}
              className={`q-opt${cls ? ' ' + cls : ''}`}
              onClick={() => !isChecked && onToggle(qIdx, optIdx)}
              style={isChecked ? { pointerEvents: 'none' } : undefined}
            >
              <input type={multi ? 'checkbox' : 'radio'} readOnly checked={isSel} />
              <span style={{ whiteSpace: 'pre-wrap' }}>{String.fromCharCode(65 + optIdx)}. {opt}</span>
            </div>
          );
        })}
      </div>

      {canCheck && (
        <div style={{ marginTop: '16px', textAlign: 'center' }}>
          <button className="btn btn-blue" onClick={() => onCheck(qIdx)}>Check Answer</button>
        </div>
      )}

      {isChecked && (
        <div className={`q-answer-box show ${isCorrect ? 'correct-ans' : 'wrong-ans'}`}>
          {isCorrect
            ? <strong>✅ Correct!</strong>
            : <><strong>{isUnanswered ? '⚠️ Not Answered.' : '❌ Incorrect.'}</strong> Correct answer{multi ? 's' : ''}: <strong>{question.ans.map(i => `${String.fromCharCode(65 + i)}. ${question.opts[i]}`).join('  |  ')}</strong></>}
          {question.explain && (
            <div style={{ marginTop: '16px', padding: '16px', background: 'var(--blue-pale)', borderRadius: 'var(--radius)', border: '1px solid var(--blue-soft)' }}>
              <pre style={{ whiteSpace: 'pre-wrap', fontFamily: 'inherit', fontSize: '0.85rem', color: 'var(--gray-700)', margin: 0 }}>
                {question.explain}
              </pre>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default ExamQuestionCard;
